export default "__VITE_ASSET__CSnu1exI__"